
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

////////////////////////////////////
////採用情報KVアニメーション//////
////////////////////////////////////
let recruitCircle = document.querySelector(".recruit-circle");

// let tl_expand = gsap.timeline({
//   scrollTrigger: {
//     scroller: ".l-wrapper",
//     trigger: ".recruit-database",
//     start: "top+=50 top",
//     end: "bottom-=50 bottom",
//     scrub: true, //スクロールとアニメーション速度リンク
//     invalidateOnRefresh: true,
//     markers: true,
//   },
// });


// tl_expand.to(recruitCircle, { scale: 0.5 });



let mm = gsap.matchMedia();

mm.add("(min-width: 768px)", () => {
  gsap.to(recruitCircle, {
    scrollTrigger: {
      trigger: ".recruit-database",
      start: "top center",
      end: "bottom bottom",
      scrub: true, //スクロールとアニメーション速度リンク
      invalidateOnRefresh: true,
      // markers: true,
    },
    scale: 1
  });
});

mm.add("(max-width: 767px)", () => {
  gsap.to(recruitCircle, {
    scrollTrigger: {
      trigger: ".recruit-database",
      start: "top center",
      end: "center bottom",
      scrub: true, //スクロールとアニメーション速度リンク
      invalidateOnRefresh: true,
      // markers: true,
    },
    scale: 1
  });
});
